<div class="bio-flow" [ngSwitch]="step" [class.bio-flow--capture]="step === Step.CAPTURE_FRONT || step === Step.CAPTURE_BACK">

  <!-- INTRO -->
  <div *ngSwitchCase="Step.INTRO" class="bio-panel bio-intro">
    <div class="bio-intro-body">
      <div class="bio-intro-hero" aria-hidden="true">
        <img
          class="bio-intro-chapita"
          src="assets/icons/Chapita.svg"
          alt=""
        />
      </div>
      <h2 class="bio-title bio-title--center bio-intro-title" id="bio-intro-title">Verifiquemos tu identidad</h2>
      <p class="bio-subtitle bio-subtitle--center bio-intro-desc" id="bio-intro-desc">
        Vamos a pedirte una foto del frente y dorso de tu DNI, para proteger tu cuenta.
      </p>
      <ul class="bio-feature-list" aria-label="Pasos de verificación">
        <li class="bio-feature-item">
          <span class="bio-feature-icon" aria-hidden="true">
            <img class="bio-feature-icon-img" src="assets/icons/dni-red.svg" alt="" width="24" height="24" />
          </span>
          <span class="bio-feature-copy">
            <span class="bio-feature-title">Fotos de tu DNI</span>
            <span class="bio-feature-text">Asegurate de tenerlo a mano</span>
          </span>
        </li>
        <li class="bio-feature-item">
          <span class="bio-feature-icon" aria-hidden="true">
            <img class="bio-feature-icon-img" src="assets/icons/camera-red.svg" alt="" width="24" height="24" />
          </span>
          <span class="bio-feature-copy">
            <span class="bio-feature-title">Reconocimiento facial</span>
            <span class="bio-feature-text">Para verificar que sos una persona real.</span>
          </span>
        </li>
      </ul>
      <p class="bio-disclaimer bio-disclaimer--center bio-intro-disclaimer">
        Usamos esta información solo para validar tu identidad y cumplir con requisitos de seguridad.
      </p>
    </div>
    <div class="bio-actions-footer bio-intro-actions">
      <button
        type="button"
        class="bio-button-primary"
        (click)="start()"
        aria-labelledby="bio-intro-title"
        aria-describedby="bio-intro-desc"
      >
        Empecemos
      </button>
    </div>
  </div>

  <!-- CAMERA_PERMISSION -->
  <div *ngSwitchCase="Step.CAMERA_PERMISSION" class="bio-panel bio-permission">
    <div class="bio-permission-body">
      <div class="bio-permission-icon" aria-hidden="true">
        <img
          class="bio-permission-icon-img"
          src="assets/icons/camera-access.svg"
          alt=""
          width="49"
          height="49"
        />
      </div>
      <h2 class="bio-title bio-title--center bio-permission-title" id="bio-permission-title">
        Necesitamos usar tu cámara
      </h2>
      <p class="bio-subtitle bio-subtitle--center bio-permission-desc" id="bio-permission-desc">
        Vamos a usarla para tomar las fotos del DNI y completar la verificación facial.
      </p>
    </div>

    <div class="bio-permission-footer">
      <div class="bio-privacy-row">
        <mat-icon class="bio-privacy-lock" aria-hidden="true">lock</mat-icon>
        <p class="bio-disclaimer">No vamos a acceder a otros archivos ni fotos de tu dispositivo.</p>
      </div>
      <p class="bio-disclaimer" *ngIf="permissionBlocked" role="note">
        Para continuar, habilitá el acceso a la cámara desde la configuración de tu navegador.
      </p>
      <div class="bio-actions-footer bio-permission-actions">
        <button
          type="button"
          class="bio-button-primary"
          (click)="requestPermissionAndStart()"
          [disabled]="starting"
          [attr.aria-busy]="starting"
          aria-labelledby="bio-permission-title"
          aria-describedby="bio-permission-desc"
        >
          {{ starting ? 'Solicitando acceso...' : 'Permitir acceso' }}
        </button>
      </div>
    </div>
  </div>

  <!-- NO_CAMERA -->
  <div *ngSwitchCase="Step.NO_CAMERA" class="bio-panel bio-permission bio-no-camera">
    <div class="bio-permission-body">
      <div class="bio-permission-icon" aria-hidden="true">
        <img
          class="bio-permission-icon-img"
          src="assets/icons/camera-access.svg"
          alt=""
          width="48"
          height="48"
        />
      </div>
      <h2 class="bio-title bio-title--center bio-permission-title" id="bio-no-camera-title">
        Necesitamos usar tu cámara
      </h2>
      <p class="bio-subtitle bio-subtitle--center bio-permission-desc" id="bio-no-camera-desc">
        Instalá una cámara en este dispositivo o ingresá desde un dispositivo móvil.
      </p>
    </div>

    <div class="bio-permission-footer">
      <div class="bio-actions-footer bio-permission-actions">
        <button
          type="button"
          class="bio-button-primary"
          (click)="exit.emit()"
          aria-labelledby="bio-no-camera-title"
          aria-describedby="bio-no-camera-desc"
        >
          Aceptar
        </button>
      </div>
    </div>
  </div>

  <!-- CAPTURE_FRONT -->
  <div *ngSwitchCase="Step.CAPTURE_FRONT" class="bio-capture-screen">
    <p class="bio-capture-instruction">
      Ubicá el frente de tu DNI<br />
      dentro del recuadro
    </p>
    <div class="bio-camera-stage">
      <video #video class="bio-video" autoplay playsinline muted (playing)="onCameraVideoReady()" aria-label="Vista previa de la cámara para el frente del DNI"></video>
      <div #frame class="bio-document-frame" [class.bio-document-frame--valid]="cameraQualityStatus === 'READY'" aria-hidden="true"></div>
      <p class="bio-capture-hint" role="status" aria-live="polite">{{ cameraHint }}</p>
    </div>
    <div class="bio-camera-actions">
      <button
        type="button"
        class="bio-cam-side-btn"
        *ngIf="torchAvailable"
        (click)="toggleTorch()"
        [disabled]="torchPending"
        [attr.aria-pressed]="torchOn"
        [attr.aria-label]="torchOn ? 'Apagar flash' : 'Encender flash'"
      >
        <mat-icon>{{ torchOn ? 'flash_on' : 'flash_off' }}</mat-icon>
      </button>
      <span class="bio-cam-side-spacer" *ngIf="!torchAvailable" aria-hidden="true"></span>
      <button type="button" class="bio-shutter" (click)="capture()" aria-label="Capturar foto del frente del DNI">
        <span class="bio-shutter-inner" aria-hidden="true"></span>
      </button>
      <button
        type="button"
        class="bio-cam-side-btn"
        *ngIf="multipleCamerasAvailable"
        (click)="switchCamera()"
        [disabled]="switchingCamera"
        aria-label="Cambiar de cámara"
      >
        <mat-icon>cameraswitch</mat-icon>
      </button>
      <span class="bio-cam-side-spacer" *ngIf="!multipleCamerasAvailable" aria-hidden="true"></span>
    </div>
    <p class="bio-error bio-error--capture" *ngIf="captureError" role="alert" aria-live="assertive">{{ captureError }}</p>
  </div>

  <!-- CAPTURE_BACK -->
  <div *ngSwitchCase="Step.CAPTURE_BACK" class="bio-capture-screen">
    <p class="bio-capture-instruction">
      Ahora da vuelta tu DNI<br />
      Ubicá el dorso dentro del recuadro
    </p>
    <div class="bio-camera-stage">
      <video #video class="bio-video" autoplay playsinline muted (playing)="onCameraVideoReady()" aria-label="Vista previa de la cámara para el dorso del DNI"></video>
      <div #frame class="bio-document-frame" [class.bio-document-frame--valid]="cameraQualityStatus === 'READY'" aria-hidden="true"></div>
      <p class="bio-capture-hint" role="status" aria-live="polite">{{ cameraHint }}</p>
    </div>
    <div class="bio-camera-actions">
      <button
        type="button"
        class="bio-cam-side-btn"
        *ngIf="torchAvailable"
        (click)="toggleTorch()"
        [disabled]="torchPending"
        [attr.aria-pressed]="torchOn"
        [attr.aria-label]="torchOn ? 'Apagar flash' : 'Encender flash'"
      >
        <mat-icon>{{ torchOn ? 'flash_on' : 'flash_off' }}</mat-icon>
      </button>
      <span class="bio-cam-side-spacer" *ngIf="!torchAvailable" aria-hidden="true"></span>
      <button type="button" class="bio-shutter" (click)="capture()" aria-label="Capturar foto del dorso del DNI">
        <span class="bio-shutter-inner" aria-hidden="true"></span>
      </button>
      <button
        type="button"
        class="bio-cam-side-btn"
        *ngIf="multipleCamerasAvailable"
        (click)="switchCamera()"
        [disabled]="switchingCamera"
        aria-label="Cambiar de cámara"
      >
        <mat-icon>cameraswitch</mat-icon>
      </button>
      <span class="bio-cam-side-spacer" *ngIf="!multipleCamerasAvailable" aria-hidden="true"></span>
    </div>
    <p class="bio-error bio-error--capture" *ngIf="captureError" role="alert" aria-live="assertive">{{ captureError }}</p>
  </div>

  <div *ngIf="(step === Step.CAPTURE_FRONT || step === Step.CAPTURE_BACK) && !cameraReady" class="bio-camera-preparing" role="status" aria-live="polite">
    <div class="bio-spinner" aria-hidden="true"></div>
    <p>Estamos preparando la verificación...</p>
  </div>

  <!-- REVIEW_FRONT -->
  <div *ngSwitchCase="Step.REVIEW_FRONT" class="bio-panel bio-review">
    <div class="bio-review-content">
      <h2 class="bio-title bio-title--center bio-review-title">¿Se lee bien la información?</h2>
      <p class="bio-subtitle bio-subtitle--center bio-review-desc">
        Asegurate de que no haya reflejos de luz y que los datos se vean nítidos.
      </p>
      <img [src]="currentPreview" class="bio-review-image" alt="Vista previa del frente del DNI capturado" />
      <ul class="bio-checklist" aria-label="Consejos de calidad de la foto">
        <li>
          <span class="bio-check-icon-wrap" aria-hidden="true">
            <mat-icon>check_circle_outline</mat-icon>
          </span>
          <span>Sin reflejos de luz</span>
        </li>
        <li>
          <span class="bio-check-icon-wrap" aria-hidden="true">
            <mat-icon>check_circle_outline</mat-icon>
          </span>
          <span>Textos legibles y enfocados</span>
        </li>
      </ul>
      <div class="bio-actions-footer bio-review-actions">
        <button type="button" class="bio-button-primary" (click)="acceptCapture()" aria-label="Usar esta foto del frente">
          Usar esta foto
        </button>
        <button type="button" class="bio-button-retake" (click)="retake()" aria-label="Volver a tomar la foto del frente">
          Volver a tomar
        </button>
      </div>
    </div>
  </div>

  <!-- REVIEW_BACK -->
  <div *ngSwitchCase="Step.REVIEW_BACK" class="bio-panel bio-review">
    <div class="bio-review-content">
      <h2 class="bio-title bio-title--center bio-review-title">¿Se lee bien la información?</h2>
      <p class="bio-subtitle bio-subtitle--center bio-review-desc">
        Asegurate de que no haya reflejos de luz y que los datos se vean nítidos.
      </p>
      <img [src]="currentPreview" class="bio-review-image" alt="Vista previa del dorso del DNI capturado" />
      <ul class="bio-checklist" aria-label="Consejos de calidad de la foto">
        <li>
          <span class="bio-check-icon-wrap" aria-hidden="true">
            <mat-icon>check_circle_outline</mat-icon>
          </span>
          <span>Sin reflejos de luz</span>
        </li>
        <li>
          <span class="bio-check-icon-wrap" aria-hidden="true">
            <mat-icon>check_circle_outline</mat-icon>
          </span>
          <span>Textos legibles y enfocados</span>
        </li>
      </ul>
      <div class="bio-actions-footer bio-review-actions">
        <button type="button" class="bio-button-primary" (click)="acceptCapture()" aria-label="Usar esta foto del dorso">
          Usar esta foto
        </button>
        <button type="button" class="bio-button-retake" (click)="retake()" aria-label="Volver a tomar la foto del dorso">
          Volver a tomar
        </button>
      </div>
    </div>
  </div>

  <!-- VALIDATING -->
  <div
    *ngSwitchCase="Step.VALIDATING"
    class="bio-panel bio-validating"
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <div class="bio-spinner" aria-hidden="true"></div>
    <p class="bio-title bio-title--center">{{ validatingMessage }}</p>
  </div>

  <!-- ERROR -->
  <div *ngSwitchCase="Step.ERROR" class="bio-overlay" role="alertdialog" aria-modal="true" aria-labelledby="bio-error-title">
    <div class="bio-modal">
      <button *ngIf="bioValidationError?.kind !== 'PROCESS_EXPIRED'" type="button" class="bio-modal-close" (click)="bioValidationError?.kind === 'FINAL_FAILED' ? retryFromError() : exit.emit()" aria-label="Cerrar">
        <mat-icon>close</mat-icon>
      </button>
      <div class="bio-modal-icon" aria-hidden="true">
        <img src="assets/icons/alert-error.svg" alt="" />
      </div>
      <h2 class="bio-modal-title" id="bio-error-title">{{ errorPanelTitle }}</h2>
      <p class="bio-modal-text">
        {{ errorPanelMessage || 'Buscá un lugar con buena luz y evitá reflejos o sombras sobre el documento.' }}
      </p>
      <div class="bio-modal-actions">
        <button *ngIf="bioValidationError?.kind !== 'FINAL_FAILED' && bioValidationError?.kind !== 'PROCESS_EXPIRED'" type="button" class="bio-button-outline" (click)="exit.emit()">Cerrar</button>
        <button type="button" class="bio-button-primary" (click)="retryFromError()">{{ bioValidationError?.kind === 'FINAL_FAILED' || bioValidationError?.kind === 'PROCESS_EXPIRED' ? 'Volver al inicio' : 'Reintentar' }}</button>
      </div>
    </div>
  </div>

  <!-- UPLOAD_FAILED -->
  <div *ngSwitchCase="Step.UPLOAD_FAILED" class="bio-overlay" role="alertdialog" aria-modal="true" aria-labelledby="bio-upload-fail-title">
    <div class="bio-modal">
      <button type="button" class="bio-modal-close" (click)="exit.emit()" aria-label="Cerrar">
        <mat-icon>close</mat-icon>
      </button>
      <div class="bio-modal-icon bio-modal-icon--warn" aria-hidden="true">
        <mat-icon>warning</mat-icon>
      </div>
      <h2 class="bio-modal-title" id="bio-upload-fail-title">No pudimos cargar tus fotos</h2>
      <p class="bio-modal-text">
        {{ uploadErrorMessage || 'Revisá tu conexión e intentá nuevamente.' }}
      </p>
      <div class="bio-modal-actions">
        <button type="button" class="bio-button-outline" (click)="exit.emit()">Cerrar</button>
        <button type="button" class="bio-button-primary" (click)="retryHostUpload()">Reintentar</button>
      </div>
    </div>
  </div>

  <!-- VALIDATION_REJECTED -->
  <div *ngSwitchCase="Step.VALIDATION_REJECTED" class="bio-overlay" role="alertdialog" aria-modal="true" aria-labelledby="bio-reject-title">
    <div class="bio-modal">
      <button type="button" class="bio-modal-close" (click)="exit.emit()" aria-label="Cerrar">
        <mat-icon>close</mat-icon>
      </button>
      <div class="bio-modal-icon bio-modal-icon--warn" aria-hidden="true">
        <mat-icon>warning</mat-icon>
      </div>
      <h2 class="bio-modal-title" id="bio-reject-title">No pudimos validar tus datos</h2>
      <p class="bio-modal-text">
        {{ legacyValidationMessage || 'Contáctanos para ayudarte a continuar.' }}
      </p>
      <div class="bio-modal-actions">
        <button type="button" class="bio-button-outline" (click)="exit.emit()">Cerrar</button>
        <button type="button" class="bio-button-primary" (click)="retryAfterValidationRejected()">Reintentar</button>
      </div>
    </div>
  </div>

  <canvas #canvas class="bio-canvas-hidden" aria-hidden="true"></canvas>
</div>
